import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "ContentWrapper"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { uiLayerShadow } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const FlexWrapper = styled.div.withConfig({
  displayName: "UIOverlayContent__FlexWrapper",
  componentId: "po7odj-0"
})(["align-items:center;display:flex;height:100%;"]);
const boxShadowMixin = uiLayerShadow();
const DefaultContentWrapper = styled.div.withConfig({
  displayName: "UIOverlayContent__DefaultContentWrapper",
  componentId: "po7odj-1"
})(["background-color:white;padding:24px;text-align:center;", ";"], boxShadowMixin);
const UIOverlayContent = props => {
  const {
      children,
      ContentWrapper
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(FlexWrapper, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      children: children
    })
  }));
};
UIOverlayContent.propTypes = {
  children: PropTypes.node.isRequired,
  ContentWrapper: PropTypes.elementType.isRequired
};
UIOverlayContent.defaultProps = {
  ContentWrapper: DefaultContentWrapper
};
UIOverlayContent.displayName = 'UIOverlayContent';
export default UIOverlayContent;